/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Else, If, Then, When } from "react-if";
import { Radio, theme, InputSearch, Text } from "@nordcloud/gnui";
import { isNotEmpty } from "~/tools";
import { useHandleListSearch } from "../hooks";
import { ThresholdDataSelectItem } from "../types";

type Props = {
  optionsList: ThresholdDataSelectItem[];
  optionSelected: ThresholdDataSelectItem;
  searchable?: boolean;
  onSelect: (valueClicked?: ThresholdDataSelectItem) => void;
};

export function RadioOptionList({
  optionsList,
  optionSelected,
  searchable,
  onSelect,
}: Props) {
  const [searchedList, searchValue, onSearchUpdate] =
    useHandleListSearch(optionsList);

  return (
    <div
      css={{
        width: "100%",
        maxHeight: "22rem",
        overflow: "scroll",
        position: "relative",
      }}
    >
      <When condition={searchable}>
        <div css={{ paddingBottom: theme.spacing.spacing04 }}>
          <InputSearch
            icon="search"
            value={searchValue}
            onChange={(event) => onSearchUpdate(event.currentTarget.value)}
          />
        </div>
      </When>
      <If condition={isNotEmpty(searchedList)}>
        <Then>
          {searchedList.map(({ id, value }) => (
            <Radio
              key={id}
              value={id}
              id={id}
              labelText={value}
              checked={optionSelected.id === id}
              onChange={(event) =>
                onSelect(
                  optionsList.find(
                    (option) => event.currentTarget.value === option.id
                  )
                )
              }
            />
          ))}
        </Then>
        <Else>
          <Text>No data available.</Text>
        </Else>
      </If>
    </div>
  );
}
